import DarkAndLightModeSwitch from "component/DarkAndLightModeSwitch/DarkAndLightModeSwitch";
import Text from "component/Text";
import SignUpForm from "component/sections/SignUpForm/SignUpForm";
import useDarkMode from "hook/useDarkMode";
import { useEffect } from "react";

import { AuthPageWelcomeHeader } from "component/sections/AuthPageWelcomeHeader/AuthPageWelcomeHeader";
import useIsWhitelabelled from "hook/useIsWhitelabelled";
import { attachRadialGradientListener } from "util/CommonUtil";

const PageSignUp = () => {
  const { productName } = useIsWhitelabelled();
  const isDarkMode = useDarkMode();

  useEffect(() => {
    const container = document.getElementById("container");
    const cleanup = attachRadialGradientListener(container, isDarkMode);
    return cleanup;
  }, [isDarkMode]);

  return (
    <div
      id="container"
      className="lg:min-w-screen flex min-h-screen w-full items-center justify-center bg-light-patch-radial-gradient text-primary-text-main dark:bg-dark-patch-radial-gradient dark:text-dark-text-main"
    >
      <div className="lg:w-266 m-auto">
        <div className="fixed right-6 top-6 z-10 max-w-fit">
          <DarkAndLightModeSwitch />
        </div>

        <div className="flex flex-col items-center gap-6 p-6 xs:gap-x-16 xs:gap-y-6 xs:p-6 lg:flex-row">
          <AuthPageWelcomeHeader>
            <div className="text-body-copy-2 text-light-grey-600 dark:text-dark-text-v2 lg:w-111">
              <Text
                className="whitespace-pre"
                label={"label.text.joinToday.welcomeNote.line1"}
                args={{ productName }}
              />
              <br />
              <Text className="whitespace-pre" label={"label.text.joinToday.welcomeNote.line2"} />
              <br />
              <Text className="whitespace-pre" label={"label.text.joinToday.welcomeNote.line3"} />
            </div>
          </AuthPageWelcomeHeader>

          <SignUpForm />
        </div>
      </div>
    </div>
  );
};

export default PageSignUp;
